//noinspection JSUnusedGlobalSymbols

/**
 * ESA Component: Order (Item) Controller
 * -------------------------------------------------------------
 * @copyright (c) 2024 [Paul Höcker|PHMG](https://phmg.online). All rights reserved.
 * @license GNU General Public License version 3 or later
 * @version 1.0.0, 2024-01-01 00:00
 */

import ContentControllerBlueprint from "./components/ContentControllerBlueprint.js";

class AddressController extends ContentControllerBlueprint {
	static CID = 'address'
	static NAME = 'Address'

	contentName = 'address'

	displayData = { item_type_alias : '', item_id : 0, address_keys : null, state : 1 }

	initiate() {

		super.initiate();

		Object.assign(
			this.displayData,
			this.context[`${this.contentName}.display-content`] || {},
		);
	}

	/**
	 * On build request
	 * @param {object} requestData
	 * @returns {object}
	 */
	onPrepareRequest(requestData) {
		requestData = requestData || {};

		// Add the data from request
		const request = requestData.request || '';
		if (request === 'address.edit' || request === 'address.add' || request === 'address.delete') {
			Object.assign(requestData, {
				data : {
					item_type_alias : requestData.item_type_alias,
					item_id         : requestData.item_id,
					address_keys    : requestData.address_keys || null
				}
			});
			if (requestData.item_type_alias !== undefined) delete requestData.item_type_alias
			if (requestData.item_id !== undefined) delete requestData.item_id
			if (requestData.address_keys !== undefined) delete requestData.address_keys;
		} else if (request === 'address.display') {
			Object.assign(requestData, {
				data : this.displayData
			});
		}


		return requestData;
	}

}

export default AddressController